<template>
	<v-col cols="12" class="pa-0">	
		<v-card class="flex pa-0 background-2 round-card">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">{{ title }}</p>
				<p v-if="entityTitle" class="entity-title">&nbsp;&nbsp;{{ entityTitle }}</p>
				<v-spacer></v-spacer>
				<v-tooltip v-if="!showTable" top>
					<template v-slot:activator="{ on }">							
						<v-btn @click="showTable = !showTable" v-on="on" icon>
							<v-icon>storage</v-icon>
						</v-btn>
					</template>
					<span>Visualizza Tabella</span>
				</v-tooltip>
				<v-tooltip top v-if="!showTable">
					<template v-slot:activator="{ on }">							
						<v-btn v-on="on" icon>
							<v-icon>get_app</v-icon>
						</v-btn>
					</template>
					<span>Download</span>
				</v-tooltip>
				<v-tooltip v-else top>
					<template v-slot:activator="{ on }">							
						<v-btn @click="showTable = !showTable" v-on="on" icon>
							<v-icon>equalizer</v-icon>
						</v-btn>
					</template>
					<span>Visualizza Grafico</span>
				</v-tooltip>
				<v-tooltip top v-if="showTable">
					<template v-slot:activator="{ on }">
						<v-btn @click="$eventBusUtility.exportCSV(tableHeaders, tableChartData, 'Aquisizione_clienti')" v-on="on" icon>
							<v-icon>get_app</v-icon>
						</v-btn>
					</template>
					<span>Download</span>
				</v-tooltip>
			</v-card-title>                
			<v-divider></v-divider>
			
			<v-container class="pt-4" fluid>
				<fields-generator
					class="pt-4"
					:fieldsset.sync="infoData"
					:model="model"
					ref="fieldsgenerator"
				></fields-generator>
				<v-row>
					<v-divider></v-divider>
				</v-row>
				<v-row v-show="showTable && loaded" >
					<v-data-table
						class="background-2 w100p"
						:items="tableChartData"
						:headers="tableHeaders"
						disable-pagination
						hide-default-footer>						
					</v-data-table>
				</v-row>

				<v-row v-show="!showTable && loaded" >
					<v-col id="exportbutton"></v-col>
					<v-col cols="12">
						<stacked-columns-chart v-if="loadedData"
							:chart-data="chartData" 
							:title="title"
						></stacked-columns-chart>
					</v-col>
				</v-row>
				<v-row class="fill-height" v-show="!showTable && loaded" align="center" justify="center" >
					<div lg3 v-for="(data, d) in chartData" :key="d">
						<v-list two-line class="background-2 w100p">
							<v-list-item>
								<v-list-item-action>
									<v-icon color="primary">business</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>Totale {{data.year}}</v-list-item-title>
									<v-list-item-subtitle>{{ total(data) }}</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-list>  
					</div>
				</v-row>
			</v-container>
		</v-card>
	</v-col>
</template>

<script>
	
	import StackedColumnsChart from '@/components/common/StackedColumnsChart'

	export default {
		name: 'companies-distribution',
		components: {
			StackedColumnsChart
		},
		props: {
			modelId: Number,
			modelKey: String,
			url: String,
			title: String,
			entityTitle: String,
		},

		data() {
			return {
				loaded: false,
				loadedData: false,
				showTable: true,
				fieldsset: {},
				chartData: [],
				listButtonStyle: '',
				model: {
					[this.modelKey]: this.modelId,
				},
				infoData: {},
				tableHeaders: [
					{
						'text': 'Anno',
						'value': 'year',
						'sortable': false
					},
					{
						'text': 'Nuovi Clienti',
						'value': 'total',
						'sortable': false
					}
				]
			}
		},

		watch: {
			model: {
				handler() {
					this.getData()
				},
				deep: true,
			},

			showTable: {
				handler(newVal, oldVal) {
					if(newVal) {
						this.listButtonStyle = ''
					} else this.listButtonStyle = 'margin-right: 54px !important;'
				}
			}
		},
			
		created() {
			this.axios.post(this.url + '-info', this.model).then(response => {
				// get body data
				this.infoData = response.data.info
				this.fieldsset = response.data.info.fields

				_.forEach(this.fieldsset, (value, key) => {
					if(value.default) {
						this.$set(this.model, value.key, value.default)
					}
				})
				this.loaded = true

			}, response => {
				// error callback
			})
		},
			
		computed: {
			tableChartData() {
				let result = []

				_.forEach(this.chartData, (value, key) => {
					result.push({'total':  this.total(value)})
					if(value.year) {
						result[key]['year'] = value.year
					}
				}) 
				return result
			}
		},

		methods: {
			getData() {
				this.axios.post(this.url, this.model).then(response => {
					this.chartData = []
					this.chartData = response.data.data.datasets
					this.loadedData = true

				}, response => {
					// error callback
				})
			},

			total(data) {
				let total = 0
				_.forEach(data, (value, key) => {
					if(key != 'year')
						total += value
				}) 

				return total
			}
		},
	}
</script>